import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMRDC } from "@/api/v1-jwt/mrdc/mrdc";

export const useUpdateMRDC = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: updateMRDC,
    onSettled: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
